<template>
  <b-card header="Delivery Address">
    <section v-if="loading" class="card-loader">
      <i class="fas fa-spinner fa-spin fa-3x"></i>
    </section>
    <b-form-row>
      <b-col cols="3">
        <label>Name</label>
      </b-col>
      <b-col>
        <b-form-input
          type="text"
          required
          v-model="ui.address.firstName"
        />
      </b-col>
      <b-col>
        <b-form-input
          type="text"
          required
          v-model="ui.address.lastName"
        />
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col>
        <label>Company</label>
      </b-col>
      <b-col cols="9">
        <b-form-input
          type="text"
          v-model="ui.address.company"
        />
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col>
        <label>Street 1</label>
      </b-col>
      <b-col cols="9">
        <b-form-input
          type="text"
          required
          v-model="ui.address.street1"
        />
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col cols="4">
        <b-checkbox
          v-model="ui.address.residential"
        >
        Residential?
        </b-checkbox>
      </b-col>
      <b-col>
        <label>Street 2</label>
      </b-col>
      <b-col cols="6">
        <b-form-input
          type="text"
          v-model="ui.address.street2"
        />
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col cols="2">
        <label>City</label>
      </b-col>
      <b-col>
        <b-form-input
          type="text"
          required
          v-model="ui.address.city"
        />
      </b-col>

      <b-col cols="2">
        <label>ZIP</label>
      </b-col>
      <b-col>
        <b-form-input
          type="text"
          required
          v-model="ui.address.postal_code"
        />
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col cols="2">
        <label>Country</label>
      </b-col>
      <b-col>
        <b-form-select
          required
          v-if="countries"
          :options="niceCountries"
          v-model="ui.address.country"
          @input="handleChangeCountry"
        />
      </b-col>
      <b-col cols="2">
        <label>State</label>
      </b-col>
      <b-col>
        <b-form-select
          v-if="countries && ui.address.country && countries[ui.address.country].states"
          required
          :options="niceStates"
          v-model="ui.address.region"
        />
        <b-form-select
          v-else
          :options="[{ text:'No State', value: null }]"
          v-model="ui.address.region"
        />
      </b-col>
    </b-form-row>
  </b-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Address from '../sales-order/edit-order/Address';

export default {
  name: 'Delivery',
  props: {
    ui: { type: Object, default() { return {}; } },
    loading: { type: Boolean, default: false }
  },
  components: {
    Address,
  },
  computed: {
    ...mapGetters({
      workareaSalesOrder: 'workareaSalesOrder',
      countries: 'countries',
    }),
    niceCountries() {
      if(this.countries) {
        return Object.keys(this.countries).map((abbr) => {
          return {text: `${abbr} | ${this.countries[abbr].name}`, value: abbr}
        });
      } else {
        return {}
      }
    },
    niceStates() {
      if(this.countries) {
        const currentCountry = this.countries[this.ui.address.country];
        return Object.keys(currentCountry.states).map((abbr) => {
                 return {
                   text: `${abbr} | ${currentCountry.states[abbr] || '???'}`,
                   value: abbr
                 }
               })
      } else {
        return {};
      }
    }
  },
   methods: {
    ...mapActions({
      getWorkareaOrder: 'getWorkareaOrder',
      getCountries: 'getCountries',
    }),
    handleChangeCountry(event) {
      this.ui.address.region = null;
    },
   },
   mounted() {
    this.getCountries();
  },
}
</script>



// WEBPACK FOOTER //
// src/components/pack-and-ship/Delivery.vue